import { forwardRef, type TextareaHTMLAttributes } from "react";
import styles from "./input.module.scss";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  inputSize?: "sm" | "md" | "lg";
  error?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ inputSize = "md", error, className, ...props }, ref) => {
    const cls = [
      styles.input,
      styles[inputSize],
      error ? styles.error : "",
      className ?? "",
    ].filter(Boolean).join(" ");

    return <textarea ref={ref} className={cls} {...props} />;
  },
);

Textarea.displayName = "Textarea";
